import * as Joi from 'joi';
import { Column, Entity, JoinColumn, ManyToOne, OneToMany } from 'typeorm';
import { GenPartial } from 'typeormgen';

import InventorySatellite from '../inventory-satellites/inventory-satellite.entity';
import EpisodicItem from '../episodic-items/episodic-item.entity';
import PropStatusColor from '../prop-status-colors/prop-status-color.entity';

@Entity('cm_statuses')
export default class CmStatus extends InventorySatellite {
	static readonly tableName = 'cm_statuses';

	@Column('int')
	status_color_id: number;

	@OneToMany((type) => EpisodicItem, (episodicItem) => episodicItem.status)
	episodicItems: EpisodicItem[];

	@ManyToOne(
		(type) => PropStatusColor,
		(propStatusColor) => propStatusColor.cmStatuses
	)
	@JoinColumn({
		name: 'status_color_id',
	})
	cmStatusColor: PropStatusColor;

	static rules() {
		return {
			...InventorySatellite.rules(),
			status_color_id: Joi.number().integer(),
		};
	}

	toJSON() {
		return {
			...super.toJSON(),
			status_color_id: this.status_color_id,
		};
	}

	constructor(props?: GenPartial<CmStatus>) {
		super(props);
	}

	getColorValue(colors: PropStatusColor[]) {
		const color = colors.find((col) => col.id === this.status_color_id);
		if (!color) {
			return '#FFFFFF';
		}
		return color.value;
	}
}
